<cs-header>
  <cs-header-title>{{ LL.editExercise.alerts.updateAvailable.title() }}</cs-header-title>
</cs-header>

<cs-content>
  <div class="diff-page-body">
    <div class="diff-hint">
      {{ LL.editExercise.alerts.updateAvailable.pickerCheckboxHint() }}
    </div>

    <div class="diff-rows">
      @for (entry of diff; track entry.field) {
        <label class="diff-row">
          <!-- [ariaLabel] names the field this row is about: some rows hold a preview button
               of their own, so the row text is not a name the checkbox can rely on -->
          <cs-checkbox
            [ariaLabel]="fieldDiffLabel(entry.field)"
            [checked]="isChecked(entry.field)"
            (checkedChange)="onCheckboxChange(entry.field, $event)">
          </cs-checkbox>
          <div class="diff-text">
            <div class="field-label">{{ fieldDiffLabel(entry.field) }}</div>
            @if (isCollapsedField(entry.field)) {
              <!-- structured field (standard): generic "changed" line -->
              <div class="field-change collapsed">{{ entry.newDisplay }}</div>
            } @else if (isDescriptionField(entry.field)) {
              @if (isLongDescription(entry)) {
                <!-- long description: Current → Updated links (same old → new layout as other
                     fields); each opens the full text on its own page -->
                <div class="field-change">
                  <button type="button" class="preview-link" (click)="openCurrentDescription(entry); $event.preventDefault()">
                    {{ LL.editExercise.alerts.updateAvailable.pickerCurrentDescription() }}
                  </button>
                  <span class="arrow">→</span>
                  <button type="button" class="preview-link" (click)="openUpdatedDescription(entry); $event.preventDefault()">
                    {{ LL.editExercise.alerts.updateAvailable.pickerUpdatedDescription() }}
                  </button>
                </div>
              } @else {
                <!-- short description: inline before/after -->
                <div class="field-change">
                  <span class="old">{{ descBefore(entry) || LL.editExercise.alerts.updateAvailable.empty() }}</span>
                  <span class="arrow">→</span>
                  <span class="new">{{ descAfter(entry) || LL.editExercise.alerts.updateAvailable.empty() }}</span>
                </div>
              }
            } @else {
              <!-- simple field: inline old → new from resolved display strings -->
              <div class="field-change">
                <span class="old">{{ entry.oldDisplay }}</span>
                <span class="arrow">→</span>
                <span class="new">{{ entry.newDisplay }}</span>
              </div>
            }
          </div>
        </label>
      }
    </div>
  </div>
</cs-content>

<cs-page-action-buttons>
  <cs-button secondary (click)="ignore()">
    {{ LL.editExercise.alerts.updateAvailable.pickerIgnoreButton() }}
  </cs-button>
  <cs-button primary [disabled]="!canApply" (click)="applySelected()">
    {{ LL.editExercise.alerts.updateAvailable.pickerApplyButton({ count: selected.size }) }}
  </cs-button>
</cs-page-action-buttons>
